import type { Degree } from "@pdfking/math"
import type { PlotFunction } from "./PlotFunction"

// Base type for common properties
export type BasePlotObject = {
  enum: PlotFunction
  rotation?: Degree
}

// Base type for common properties
export type ConcretePlotObject = {
  fill_color?: string
  stroke_color?: string
} & BasePlotObject
